import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "StairsUp.svg",
  "use": "StairsUp.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"StairsUp.svg\"><path d=\"M54,52H10a2,2,0,0,1-2-2V44a2,2,0,0,1,2-2h9a1,1,0,0,0,1-1V34a2,2,0,0,1,2-2h9a1,1,0,0,0,1-1V24a2,2,0,0,1,2-2h9a1,1,0,0,0,1-1V14a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2V50A2,2,0,0,1,54,52ZM21.9979,25.9757a2,2,0,0,1-2.0017-1.9981V18.8365L11.372,27.4139a1.9893,1.9893,0,1,1-2.8043-2.8224l8.642-8.5954H11.9775a1.9981,1.9981,0,1,1,0-3.9961h10.02A2,2,0,0,1,24,13.998v9.98A2,2,0,0,1,21.9979,25.9757Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol